import React from "react";

const Map = () => {
  return (
    <div className="mb-10">
      <div
        className="flex justify-center items-center "
        style={{ maxWidth: "1440px", margin: "auto" }}
      >
        <div className="w-full max-md:mx-4  rounded-[20px]">
          <iframe
            title="Gir Somnath Map"
            className="w-full h-[500px] rounded-[20px] poppins-regular "
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9445.703262481435!2d70.3885!3d20.888!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sGir%20Somnath%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1632995005001"
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Map;
